module.exports = __webpack_public_path__ + "static/media/0002.4d1e52b0.JPG";